var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tree-select" }, [
    _c(
      "div",
      { staticClass: "tree-select-input", on: { click: _vm.toggleDropdown } },
      [
        _vm.selectedLabels.length
          ? _c("span", [_vm._v(_vm._s(_vm.selectedLabels.join(", ")))])
          : _c("span", { staticClass: "placeholder" }, [
              _vm._v("בחר ערך מהרשימה"),
            ]),
        _c("span", { staticClass: "arrow" }, [
          _vm._v(_vm._s(_vm.isOpen ? "▲" : "▼")),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen",
          },
        ],
        staticClass: "tree-dropdown",
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText",
            },
          ],
          staticClass: "tree-search",
          attrs: { type: "text", placeholder: "חיפוש..." },
          domProps: { value: _vm.searchText },
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.searchText = $event.target.value
            },
          },
        }),
        _c(
          "div",
          { staticClass: "tree-items" },
          _vm._l(_vm.filteredItems, function (item) {
            return _c("tree-item", {
              key: item.id,
              attrs: { item: item, selected: _vm.value },
              on: { toggle: _vm.handleToggle },
            })
          }),
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }